import React from "react";
import SectionArticleOrEventCards from "../../../containers/sections/SectionArticleOrEventCards";
import { useStaticData } from "../../../hooks/useStaticData";
import { mapBreedToSignPostCards } from "../../../utils/mappers";
import WrappedSection from "../../WrappedSection/WrappedSection";
import * as styles from "./SectionBreedList.module.scss";

export interface SectionBreedListProps {
	heading: string;
	htmlText: string;
	jumpLinksTitle?: string;
}

// TODO - TEST STATIC
export const getSectionBreedListProps = ({
	field_front_end_title,
	field_section_short_description,
	field_jump_links_title,
}: Queries.SectionDataFragment) => ({
	heading: field_front_end_title,
	htmlText: field_section_short_description?.value,
	jumpLinksTitle: field_jump_links_title,
});
export const SectionBreedList: React.FC<SectionBreedListProps> = ({
	heading,
	htmlText,
	jumpLinksTitle,
}) => {
	const { dogBreeds } = useStaticData(["dogBreeds"]);

	return (
		<WrappedSection sectionName="SectionBreedList">
			<div className={styles.breedlistinner}>
				{jumpLinksTitle ? (
					<h2 data-jumplinkstitle={jumpLinksTitle} className={styles.title}>
						{heading}
					</h2>
				) : (
					<h2 className={styles.title}>{heading}</h2>
				)}
				<div
					className={styles.textWrapper}
					// biome-ignore lint/security/noDangerouslySetInnerHtml: Safe source
					dangerouslySetInnerHTML={{
						__html: htmlText,
					}}
				/>
				<SectionArticleOrEventCards
					forceFlatCards={true}
					displayOption={"loader"}
					items={(dogBreeds as unknown as Queries.node__breed[]).map(
						mapBreedToSignPostCards,
					)}
					noWrapper
				/>
			</div>
		</WrappedSection>
	);
};

export default SectionBreedList;
